function Buffer() {
	throw new Error("Buffer is not included.");
}
Buffer.isBuffer = function() {
  return false;
};

exports.INSPECT_MAX_BYTES = 50;
exports.SlowBuffer = Buffer;
exports.Buffer = Buffer;



//////////////////
// WEBPACK FOOTER
// (webpack)/~/node-libs-browser/mock/buffer.js
// module id = 1907
// module chunks = 0